import { api, endpoints } from "api/api";
import { BaseApiPaging, UserSurveyApi } from "api/types";
import { AxiosPromise } from "axios";

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string,
  orderBy: string
): AxiosPromise<BaseApiPaging<UserSurveyApi>> => {
  return api.get<BaseApiPaging<UserSurveyApi>>(endpoints.USER_SURVEYS.GET(skip, take, searchPhrase, filter, orderBy));
};

const fetchById = (userSurveyId: number): AxiosPromise<UserSurveyApi> => {
  return api.get<UserSurveyApi>(endpoints.USER_SURVEYS.GET_BY_ID(userSurveyId));
};

export const userSurveysApi = {
  fetch,
  fetchById,
};
